import React from 'react';
import {connect} from 'react-redux';

import strings from 'utils/strings';

import {updateObject} from 'utils/reducerUtils';

import classNames from 'classnames';
import Countdown from 'components/Countdown';

import questionsNo from './languages/no-questions.json';
import questionsNn from './languages/nn-questions.json';

import textNo from './languages/no-text';
import textNn from './languages/nn-text';
import StopWatch from 'components/StopWatch';

import normingQuestionsNo from './languages/no-norming-questions.json';
import normingTextNo from './languages/no-norming-text.js';

import normingQuestionsNn from './languages/nn-norming-questions.json';
import normingTextNn from './languages/nn-norming-text.js';

const questionsObj = {
	no: questionsNo,
	nn: questionsNn,
};

const textObj = {
	no: textNo,
	nn: textNn,
};

const normingQuestionsObj = {
	no: normingQuestionsNo,
	nn: normingQuestionsNn,
};

const normingTextObj = {
	no: normingTextNo,
	nn: normingTextNn,
};

class Test extends React.Component {
	constructor(props) {
		super(props);
		const isDldTest = this.props.isDldTest ? 1 : 0;

		this.questions =
			isDldTest === 1
				? normingQuestionsObj[strings.getLanguage()]
				: questionsObj[strings.getLanguage()];
		this.testText =
			isDldTest === 1
				? normingTextObj[strings.getLanguage()]
				: textObj[strings.getLanguage()];

		this.choiceLetterKey = isDldTest === 1 ? 'identity' : 'letter';

		const results = {};

		for (const question of this.questions) {
			results[question.id] = '';
		}
		this.state = {
			results,
			timeRanOut: false,
			timeUsedInSeconds: null,
		};
	}

	setResults(id, value) {
		const {results} = this.state;

		this.setState({
			results: updateObject(results, {
				[id]: value,
			}),
		});
	}
	updateTimeUsed = (timeUsed) => {
		const {results, timeRanOut} = this.state;
		const allResultsHasValues = Object.keys(results).every(
			(key) => results[key]
		);
		if (allResultsHasValues || timeRanOut) {
			this.setState({
				timeUsedInSeconds: timeUsed,
			});
		}
	};
	render() {
		//TODO ADD TEXTS TO
		const {onNextStep, isSendingTestResults} = this.props;

		const {results, timeRanOut} = this.state;

		const allResultsHasValues = Object.keys(results).every(
			(key) => results[key]
		);
		const isNextButtonVisible = allResultsHasValues || timeRanOut;

		return (
			<div className="lit-test lit-leseproven">
				<div className="lit-stop-watch-div">
					<StopWatch autoStart integer onTick={this.updateTimeUsed} />
				</div>
				<div className="lit-infobar">
					<Countdown
						duration={10 * 60}
						onComplete={() => {
							this.setState({
								timeRanOut: true,
							});
						}}
					/>
				</div>
				<div className="story">{this.testText}</div>
				<div
					className={classNames({
						'lit-questions': true,
						'time-ran-out': timeRanOut,
					})}
				>
					<div className="questions-intro">
						<h2 className="lit-page-title">Spørsmål til teksten</h2>
						<p>Trykk på riktig alternativ</p>
					</div>
					{this.questions.map((question) => {
						const {id, choices} = question;

						const currentQuestionValue = results[id];

						return (
							<div className="lit-question" key={id}>
								<div className="question">
									<span className="lit-input__label lit-input__label--count">
										{id}
									</span>
									<h4 className="question__text">
										{question.question}
									</h4>
								</div>
								<div className="choices">
									{choices.map((choice) => {
										const choiceLetter =
											choice[this.choiceLetterKey];
										const idChoice = id + choiceLetter;
										return (
											<span
												className="lit-choice"
												key={idChoice}
											>
												<input
													checked={
														currentQuestionValue ===
														choiceLetter
													}
													className="lit-choice__field"
													disabled={timeRanOut}
													id={idChoice}
													onChange={() =>
														this.setResults(
															id,
															choiceLetter
														)
													}
													type="radio"
												/>
												<label
													className="lit-choice__label"
													htmlFor={idChoice}
												>
													<div className="checkbox" />
													{choice.choice}
												</label>
											</span>
										);
									})}
								</div>
							</div>
						);
					})}
				</div>

				{isNextButtonVisible && (
					<button
						className="lit-btn bg-primary"
						onClick={() =>
							onNextStep(results, this.state.timeUsedInSeconds)
						}
						disabled={isSendingTestResults}
					>{`Ferdig`}</button>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		testStepAnswers: {isSendingTestResults},
	} = state;

	return {
		isSendingTestResults,
	};
};

export default connect(mapStateToProps)(Test);
